const commentsData = [
  {
    name: '追漫十年',
    avatar: '追',
    content: '用UU漫画追更半年了，更新提醒真的超及时！海贼王和咒术回战每次更新都能第一时间看到，追漫必备神器无疑。',
    comic: '追更《海贼王》《咒术回战》',
    time: '2小时前',
  },
  {
    name: '深夜漫迷',
    avatar: '漫',
    content: '之前总是漏掉连载漫画的更新，有了UU漫画之后再也没错过。免费漫画全集随便看，漫画更新提醒太贴心了。',
    comic: '追更《间谍过家家》《坂本日常》',
    time: '5小时前',
  },
  {
    name: '二次元居民',
    avatar: '二',
    content: '漫画索引功能特别棒，按品类找漫画很方便。胆大党和怪兽8号的更新速度很快，最新漫画更新基本同步日本。',
    comic: '追更《胆大党》《怪兽8号》',
    time: '昨天',
  },
  {
    name: '摸鱼大师',
    avatar: '鱼',
    content: '上班摸鱼必备（不是）。咳咳，认真说UU漫画的免费漫画全集资源确实很全，连载漫画追更体验一流。',
    comic: '追更《坂本日常》《我推的孩子》',
    time: '昨天',
  },
  {
    name: '新入坑小白',
    avatar: '新',
    content: '刚入坑漫画坑，UU漫画的漫画索引帮了大忙，从热血到恋爱按品类选很方便。追更榜单也让我发现了不少好作品。',
    comic: '追更《咒术回战》《间谍过家家》',
    time: '2天前',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[960px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            漫迷心声
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            真实的追漫同好分享他们的UU漫画追更体验
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {commentsData.map((c) => (
            <div key={c.name} className="bg-background-50 rounded-xl p-5 flex flex-col">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 rounded-full bg-accent-100 text-accent-600 flex items-center justify-center font-heading font-bold text-sm flex-shrink-0">
                  {c.avatar}
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-foreground-800">{c.name}</div>
                  <div className="text-[11px] text-foreground-400">{c.time}</div>
                </div>
              </div>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed flex-1 mb-3">
                {c.content}
              </p>
              <div className="flex items-center gap-1.5 text-[11px] text-foreground-400">
                <i className="ri-book-open-line"></i>
                <span>{c.comic}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}